
const Components = {};



Components[ 'raw' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    return JSON.stringify(record[ handle ] ?? null, null, 2);
  },

  Output: ({ handle, meta, record }) => {
    return JSON.stringify(record[ handle ] ?? null, null, 2);
  }
};




Components[ 'text' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    return (
      <input
        value={record[ handle ] ?? ''}
        onChange={(e) => onFieldChange(handle, e.target.value)}
        required={meta.required}
      />
    );
  },

  Output: ({ handle, meta, record }) => {
    return record[ handle ] || '-';
  }
};




Components[ 'textarea' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    return (
      <textarea
        value={record[ handle ] ?? ''}
        onChange={(e) => onFieldChange(handle, e.target.value)}
        required={meta.required}
      />
    );
  },

  Output: ({ handle, meta, record }) => {
    return record[ handle ] ? <p>{record[ handle ]}</p> : '-';
  }
};




Components[ 'boolean' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    return (
      <input
        type="checkbox"
        checked={Boolean(record[ handle ])}
        onChange={(e) => onFieldChange(handle, e.target.checked)}
        required={meta.required}
      />
    );
  },

  Output: ({ handle, meta, record }) => {
    return (
      <input
        type="checkbox"
        checked={Boolean(record[ handle ])}
        disabled={true}
      />
    );
  }
};




Components[ 'list' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    return (
      <table className="data-table">
        <thead>
          <tr>
            {meta?.fields.map( ( field ) => (
              <th key={field.handle}>{field.label}</th>
            ) )}
          </tr>
        </thead>
        <tbody>
          {record[ handle ].map((row, rowIndex) => {

            const key = row?.id || row?.slug || row?.handle || row?.key || `row-${rowIndex}`;

            return (
              <tr key={key}>
                {meta?.fields.map( ( field ) => (
                  <td key={`${key}-${field.handle}`}>{row?.[ field.handle ]}</td>
                ) )}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  },

  Output: ({ handle, meta, record }) => {
    return (
      <table className="data-table">
        <thead>
          <tr>
            {meta?.fields.map( ( field ) => (
              <th key={field.handle}>{field.label}</th>
            ) )}
          </tr>
        </thead>
        <tbody>
          {record[ handle ].map((row, rowIndex) => {

            const key = row?.id || row?.slug || row?.handle || row?.key || `row-${rowIndex}`;

            return (
              <tr key={key}>
                {meta.fields.map( ( field ) => (
                  <td key={`${key}-${field.handle}`}>{row?.[ field.handle ]}</td>
                ) )}
              </tr>
            );
          })}
        </tbody>
      </table>
    );
  }
};




Components[ 'select' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    return (
      <select
        value={record[ handle ].value ?? ''}
        onChange={(e) => onFieldChange(handle, { ...record[ handle ], value: e.target.value })}
        required={meta.required}
      >
        <option value={record[ handle ].value ?? ''}>{record[ handle ].label ?? record[ handle ].value ?? '-'}</option>
      </select>
    );
  },

  Output: ({ handle, meta, record }) => {
    return record[ handle ] ? record[ handle ].label : '-';
  }
};




Components[ 'model' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {
    return record[ handle ];
  },

  Output: ({ handle, meta, record }) => {
    return record[ handle ];
  }
};




Components[ 'field' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {

    const Components = require( '../../../elements' ).default;

    const Component = Components.Meta.domain( 'selection' );

    return (
      <div className="record-details-grid">

        <div className="">
          <span className="kv-label">Type</span>
          <div className="">
            <select
              value={record[ handle ].value}
              onChange={(e) => onFieldChange(handle, { value: e.target.value, meta: {} })}
              required={meta.required}
            >
              {[...new Set([record[handle].value, 'computed', 'rollup'])].map((type) => (
                <option key={type} value={type}>
                  {Components.Data.identity1()[type]?.label || type}
                </option>
              ))}
            </select>
          </div>
        </div>

        {Component.Input({
          handle: 'meta',
          meta: {
            label: Components.Data.identity1()[ record[ handle ].value ].label,
            fields: Components.Data.identity1()[ record[ handle ].value ].fields
          },
          domain: record[ handle ],
          updateDomain: (nextValue) => {
            onFieldChange(handle, nextValue);
          }
        })}

      </div>
    );
  },

  Output: ({ handle, meta, record }) => {

    const Components = require( '../../../elements' ).default;

    const Component = Components.Meta.domain( 'selection' );

    return (
      <div className="record-details-grid">

        <div className="">
          <span className="kv-label">Type</span>
          <div className="">
            {Components.Data.identity1()[ record[ handle ].value ].label}
          </div>
        </div>

        {Component.Output({
          handle: 'meta',
          meta: {
            label: Components.Data.identity1()[ record[ handle ].value ].label,
            fields: Components.Data.identity1()[ record[ handle ].value ].fields
          },
          domain: record[ handle ]
        })}

      </div>
    );
  }
};




Components[ 'domain' ] = {

  Input: ({ handle, meta, record, context, onFieldChange }) => {

    const Components = require( '../../../elements' ).default;

    const Component = Components.Meta.domain( 'selection' );

    return (
      <div className="record-details-grid">

        <div className="">
          <span className="kv-label">Type</span>
          <div className="">
            <select
              value={record[ handle ].value}
              onChange={(e) => onFieldChange(handle, { value: e.target.value, meta: {} })}
              required={meta.required}
            >
              <option value={record[ handle ].value}>
                {Components.Data.domain1()[ record[ handle ].value ].label}
              </option>
            </select>
          </div>
        </div>
          
        {Component.Input({
          handle: 'meta',
          meta: {
            label: Components.Data.domain1()[ record[ handle ].value ].label,
            fields: Components.Data.domain1()[ record[ handle ].value ].fields
          },
          domain: record[ handle ],
          updateDomain: (nextDomain) => {
            onFieldChange(handle, nextDomain);
          }
        })}

      </div>
    );
  },

  Output: ({ handle, meta, record }) => {

    const Components = require( '../../../elements' ).default;

    const Component = Components.Meta.domain( 'selection' );

    return (
      <div className="record-details-grid">

        <div className="">
          <span className="kv-label">Type</span>
          <div className="">
            {Components.Data.domain1()[ record[ handle ].value ].label}
          </div>
        </div>
          
        {Component.Output({
          handle: 'meta',
          meta: {
            label: Components.Data.domain1()[ record[ handle ].value ].label,
            fields: Components.Data.domain1()[ record[ handle ].value ].fields
          },
          domain: record[ handle ]
        })}

      </div>
    );
  }
};




export default Components;
